import { render, staticRenderFns } from "./infinite-list-footer.vue?vue&type=template&id=0c43691a&scoped=true&"
import script from "./infinite-list-footer.vue?vue&type=script&lang=js&"
export * from "./infinite-list-footer.vue?vue&type=script&lang=js&"
import style0 from "./infinite-list-footer.vue?vue&type=style&index=0&id=0c43691a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43691a",
  null
  
)

export default component.exports